import React from 'react';

type IconProps = {
    colorBody?: string;
    colorHead?: string;
    colorStar?: string;
    width?: number;
    height?: number;
    color?: string;
};

const IconShareBare: React.FC<IconProps> = ({ width = 17, height = 17, color = 'black' }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.46993 14.293C9.46993 14.6244 9.73855 14.893 10.0699 14.893C10.4013 14.893 10.6699 14.6244 10.6699 14.293V3.40804L13.5985 6.33658C13.8328 6.5709 14.2127 6.5709 14.447 6.33658C14.6813 6.10228 14.6813 5.72238 14.447 5.48806L10.502 1.54305C10.3863 1.42734 10.2351 1.36877 10.0834 1.36734C10.0789 1.36724 10.0744 1.36719 10.0699 1.36719C10.0611 1.36719 10.0523 1.36738 10.0435 1.36776C9.88245 1.36163 9.71933 1.42006 9.59633 1.54306L5.65133 5.48806C5.41701 5.72238 5.41701 6.10228 5.65133 6.3366C5.88565 6.57092 6.26555 6.57092 6.49985 6.3366L9.46993 3.36652V14.293Z"
                fill={color}
            />
            <path
                d="M2.77325 11.4281C2.77325 11.0968 2.50461 10.8281 2.17325 10.8281C1.84187 10.8281 1.57324 11.0968 1.57324 11.4281V16.0251C1.57324 17.461 2.73731 18.6251 4.17325 18.6251H15.8259C17.2618 18.6251 18.4259 17.461 18.4259 16.0251V11.4281C18.4259 11.0968 18.1573 10.8281 17.8259 10.8281C17.4945 10.8281 17.2259 11.0968 17.2259 11.4281V16.0251C17.2259 16.7983 16.5991 17.4251 15.8259 17.4251H4.17325C3.40005 17.4251 2.77325 16.7983 2.77325 16.0251V11.4281Z"
                fill={color}
            />
        </svg>
    );
};

export default IconShareBare;
